import { getLocalUser } from "../Util/User";

function updateItem(key, property, value) {
  let obj = JSON.parse(localStorage.getItem(key));
  obj[property] = value;
  localStorage.setItem(key, JSON.stringify(obj));
}

const fetchAudioBlob = async (url, token = null) => {
  const localUser = getLocalUser();
  let data = '';
  let jwt = {};

  if (token === null) {
    jwt.Authorization = `Bearer ${localUser.jwtToken}`;
  } else {
    jwt.Authorization = token;
  }

  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...jwt,
    },
  };

  try {
    const response = await fetch(url, fetchOptions);

    if (response.status === 401) {
      const getNewToken = await refreshToken(url, localUser);

      if (getNewToken === false) {
        //Temp measure to force user to sign in again.
        window.location.reload();
        return;
      } else {
        // await fetchAudioBlob(url, getNewToken);
        data = await fetchAudioBlob(url, getNewToken);
        return data;
      }

      // return;
    }

    if (response.ok === true) {
      const blob = await response.blob();

      data = blob;
    }
  } catch (error) {
    console.error(error);
  }

  return data;
};

/**
 *
 * @param {string} url - url to retry
 * @param {object} user - localstorage user
 * @returns
 */
const refreshToken = async (url, user) => {
  if (!Object.prototype.hasOwnProperty.call(user, 'refreshToken')) return false;

  const refreshOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: `refreshToken=${user.refreshToken}`,
  };

  const { apiUrl } = window['appConfig'];
  const response = await fetch(`${apiUrl}/user/refreshaccess`, refreshOptions);

  if (response.status !== 200) {
    return false;
  }

  const data = await response.json();
  updateItem('user', 'jwtToken', data.jwtToken);
  updateItem('user', 'refreshToken', data.refreshToken);

  const jwtToken = `Bearer ${data.jwtToken}`;
  // fetchAudioBlob(url, jwtToken)
  return jwtToken;
};

export const fetchNpcAudio = async (sentence, sceneID) => {
  const { apiUrl } = window['appConfig'];

  // let tempBlobs = {};
  const fetchUrl = `${apiUrl}/conversation/speak/${sceneID}/${sentence.sentenceNumber}?format=mp3`;
  let npcBlob = await fetchAudioBlob(fetchUrl);

  return npcBlob;
};

export const fetchAudio = async (sentence, sceneID) => {
  const { apiUrl } = window['appConfig'];

  let tempBlobs = {};

  for (let p = 0; p < sentence.splits.length; p++) {
    const fetchUrl = `${apiUrl}/conversation/speak/${sceneID}/${sentence.sentenceNumber}/${sentence.splits[p].splitNumber}?format=mp3`;
    let blob = await fetchAudioBlob(fetchUrl);

    try {
      tempBlobs[sentence.splits[p].splitNumber] = blob;
    } catch (err) {
      console.warn(
        `Failed to push blob for sentence: ${sentence.splitNumber} split ${sentence.parts[p].splitNumber}: ${err}`,
      );
    }
  }

  // console.log(tempBlobs);
  return tempBlobs;
};

function doesFileExist(urlToFile) {
  var xhr = new XMLHttpRequest();
  xhr.open('HEAD', urlToFile, false);
  xhr.send();
  if (xhr.status == "404") {
      return false;
  } else {
      return true;
  }
}

export const fetchNpcIcon = (location) => {
  let formattedLocation = location.replace(' ', '-').toLowerCase();
  let url = `${window.location.protocol}//${window.location.host}/npc/${formattedLocation}-npc.png`;

  let npcIconUrl = doesFileExist(url) ? url : '/npc/polly-npc.png';

  return npcIconUrl;

}

